import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Typography } from 'antd';
import { SelectPlus } from 'Components/SelectPlus';
import { InputDate } from 'Components/Inputs/InputDate';
import { SelectUser } from '@/features/users/components/SelectUser';
import { SelectServiceType } from '@features/vehicles/components/SelectServiceType';
import { SelectVehicleState } from '@features/vehicles/components/SelectVehicleState';
import { SelectVehicleClass } from '@features/vehicles/components/SelectVehicleClass';
import { SelectUtilitarian } from '@features/vehicles/components/SelectUtilitarian';
import { SelectMunicipality } from '@features/locations/components/SelectMunicipality';
import { setFiltersQuotationsTable } from 'Redux/actions/tableQuotations';
import { DEFAULT_QUOTATION_FILTERS } from '@constants/quotationFilters';
import { FiltersToolbar } from '@shared/components/FiltersToolbar';

const { Text } = Typography;

/** Retorna la opción para filtrar los registros sin relación con la entidad especificada. */
const getNoEntityOption = (entity) => ({
  value: 0,
  label: <Text italic type='secondary'>Sin {entity}</Text>,
  order: -1,
});

const Filters = ({
  storedAppliedFilters,
  setStoredAppliedFilters,
  onChange,
  // softsegurosVendedores,
  aseguradorasMarca,
  branches,
}) => {
  const branchOptions = branches.map((record) => ({
    value: record.id,
    label: record.name,
    record,
  }));

  // const sellerOptions = [
  //   getNoEntityOption('vendedor'),
  //   ...softsegurosVendedores.map((record) => ({
  //     value: record.id,
  //     label: record.nombre,
  //     record,
  //   })),
  // ];

  const insuranceCarrierOptions = [
    getNoEntityOption('aseguradora'),
    ...aseguradorasMarca.map((record) => ({
      value: record.id,
      label: record.name,
      record,
    })),
  ];

  const handleSearch = (values) => {
    setStoredAppliedFilters(values); // Guarda los filtros aplicados en el estado global
    onChange?.();
  };

  return (
    <FiltersToolbar
      defaultFilters={DEFAULT_QUOTATION_FILTERS}
      initialFilters={storedAppliedFilters}
      onSearch={handleSearch}
      items={[
        {
          name: 'branches',
          label: 'Sedes',
          component: (
            <SelectPlus
              mode='multiple'
              placeholder='Seleccionar sedes'
              allowClear
              options={branchOptions}
              popupMatchSelectWidth // Hace que el menú desplegable tenga siempre el mismo ancho que el componente SelectPlus
            />
          ),
        },
        {
          name: 'createdBy',
          label: 'Creado por',
          component: <SelectUser mode='multiple' />,
        },
        // {
        //   name: 'advisors',
        //   label: 'Vendedores',
        //   component: (
        //     <SelectPlus
        //       mode='multiple'
        //       placeholder='Seleccionar vendedores'
        //       allowClear
        //       options={sellerOptions}
        //     />
        //   ),
        //   visible: !!softsegurosVendedores.length,
        // },
        {
          name: 'insuranceCarriers',
          label: 'Aseguradoras',
          component: (
            <SelectPlus
              mode='multiple'
              placeholder='Seleccionar aseguradoras'
              allowClear
              options={insuranceCarrierOptions}
            />
          ),
        },
        {
          type: 'group',
          label: 'Fecha de cotización',
          items: [
            {
              name: 'createdAtStart',
              label: 'Desde',
              component: <InputDate />,
            },
            {
              name: 'createdAtEnd',
              label: 'Hasta',
              component: <InputDate />,
            },
          ],
        },
        {
          type: 'group',
          label: 'Fecha de actualización',
          items: [
            {
              name: 'updatedAtStart',
              label: 'Desde',
              component: <InputDate />,
            },
            {
              name: 'updatedAtEnd',
              label: 'Hasta',
              component: <InputDate />,
            },
          ]
        },
        {
          type: 'title',
          label: 'Vehículo',
        },
        {
          name: 'vehicleStates',
          label: 'Estado del vehículo',
          component: <SelectVehicleState mode='multiple' allowClear />,
        },
        {
          type: 'group',
          label: 'Modelo',
          items: [
            {
              name: 'vehicleModelStart',
              label: 'Desde',
              component: <InputDate picker='year' />,
            },
            {
              name: 'vehicleModelEnd',
              label: 'Hasta',
              component: <InputDate picker='year' />,
            },
          ],
        },
        {
          name: 'vehicleClasses',
          label: 'Clases',
          component: <SelectVehicleClass mode='multiple' allowClear />,
        },
        {
          name: 'vehicleCirculationCities',
          label: 'Ciudades de circulación',
          component: (
            <SelectMunicipality
              mode='multiple'
              placeholder='Seleccionar ciudades de circulación'
              allowClear
            />
          ),
        },
        {
          name: 'vehicleServiceTypes',
          label: 'Tipo de servicio',
          component: <SelectServiceType mode='multiple' allowClear />,
        },
        {
          name: 'vehicleIsUtilitarian',
          label: '¿Es utilitario?',
          component: <SelectUtilitarian allowClear />,
        },
      ]}
    />
  );
};

Filters.propTypes = {
  setStoredAppliedFilters: PropTypes.func,
  onChange: PropTypes.func,
  // softsegurosVendedores: PropTypes.array.isRequired,
  aseguradorasMarca: PropTypes.array.isRequired,
};

const actions = { setStoredAppliedFilters: setFiltersQuotationsTable };

const mapStateToProps = (state) => ({
  // softsegurosVendedores: state.softsegurosVendedores.vendedores,
  aseguradorasMarca: state.initialData.aseguradoras,
  branches: state.initialData.sedes,
  storedAppliedFilters: state.tableQuotations.filtersTableQuotations,
});

export default connect(mapStateToProps, actions)(Filters);
